import React from 'react';
import PropTypes from 'prop-types';
import Button from './Base';
import CustomIcons from '../Icons/CustomIcons';

const ActionButton = (
  {
    disabled,
    processing,
    children,
    ...props
  },
) => {
  const renderChildren = () => (processing ? <CustomIcons iconName="spinner" /> : children);

  return (
    <Button
      {...props}
      disabled={processing || disabled}
    >
      {renderChildren()}
    </Button>

  );
};

ActionButton.propTypes = {
  processing: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

ActionButton.defaultProps = {
  processing: false,
  children: [],
};

export default ActionButton;
